import { useSelector } from 'react-redux';
import cn from 'classnames';
import { rm } from 'utils';
import { SmallLogo } from 'components/Header/themes/BGH/smallLogo';
import styles from './logo.scss';
import { selectPhonenumber } from 'components/Footer/selector';

interface Props {
  className?: string;
}

export const Logo = ({ className }: Props) => {
  const phone = useSelector(selectPhonenumber);

  return (
    <div className={cn(styles.logo, className)}>
      <div className={styles.icon}>
        <SmallLogo />
      </div>
      <span className={styles.info}>{rm('pp_footer_logo_text').replace('{phone}', phone)}</span>
    </div>
  );
};
